<template>
    <div class="calculation-container">
        <template v-if="ci && ci.calculation">
        <div class="main-header">
            <h2 class="main-header__title">{{ ci.calculation.title }}</h2>
            <div class="main-header__description" v-html="ci.calculation.text"></div>
            <b-button class="main-header__btn" variant="primary" v-show="executionResult.length" @click="resetCalculation()">
            {{ labels.reset_to_default }}
            </b-button>
        </div>
    
        <div class="mc-history" v-if="ci && ci.structure && ci.structure.history">
            <div class="history-element" v-for="(history, hindex) in ci.structure.history" :key="'history-'+hindex">
                <span v-if="history.interface">
                    <span v-html="history.interface"></span>
                </span>
                <div class="history-element-input" v-for="(variable, hiindex) in history.variables" :key="'history-element-input-'+hiindex" >
                        <h4 v-if="ci.history[variable].title">{{ci.history[variable].title}}</h4>
                        <span v-if="ci.history[variable].text">
                            <span v-html="ci.history[variable].text"></span>
                        </span>
                        <CalculationInput :input="ci.history[variable]" :id="ci.history[variable].id" :computed-calculation-id="computedCalculationId" :displayOnly="true"/> 
                    </div>
                <div class="history-module" v-for="(historyModule, mindex) in history.children" :key="'history-module-'+mindex" >
                    <span v-if="historyModule.interface">
                        <span v-html="historyModule.interface"></span>
                    </span>
                    <div class="history-module-input" v-for="(variable, miindex) in historyModule.variables" :key="'history-module-'+miindex" >
                        <h3 v-if="ci.history[variable].title">{{ci.history[variable].title}}</h3>
                        <span v-if="ci.history[variable].text">
                            <span v-html="ci.history[variable].text"></span>
                        </span>
                        <CalculationInput :input="ci.history[variable]" :id="ci.history[variable].id" :computed-calculation-id="computedCalculationId" :displayOnly="true"/> 
                    </div>
                </div>
            </div>
        </div>
    
        <div class="mc-body" v-if="ci && ci.structure && ci.structure.request">
            <div class="user-groups">
                <div class="user-group" v-for="(ug, key) in ci.usergroups" :key="key" @click="reRenderWithUG(ug._id)" :class="{ 'active-group': ug._id == ci.currentgroup }">{{ug.title}}</div>
            </div>
            <span v-if="ci.structure.request.interface">
                <span v-html="ci.structure.request.interface"></span>
            </span>
            <div class="mc-child-input" v-for="(v,vindex) in ci.structure.request.variables" :key="vindex+'_mc-child-v'">
                <CalculationInput :input="ci.request[v]" :id="v" :computed-calculation-id="computedCalculationId" :changeFN="valueChange" />
            </div>
            <div class="mc-children" v-for="(child, index) in ci.structure.request.children" :key="index+'_mc-child'">
                <span v-if="child.interface">
                    <span v-html="child.interface"></span>
                </span>
                <div class="mc-child-input" v-for="(v,vindex) in child.variables" :key="vindex+'_mc-child-v'">
                    <CalculationInput :input="ci.request[v]" :computed-calculation-id="computedCalculationId" :id="v" :changeFN="valueChange" />
                </div>
            </div>
        </div>
        <div class="calculate-btn" v-if="canCalculate" @click="sendData">Calculate</div>
        <div class="calculate-btn reset-calculate-btn" v-else-if="canReset" @click="resetCalculation">Reset Calculation</div>
        
        </template>
        <div v-if="!dataLoaded && (!ci || typeof ci == 'object' && !Object.keys(ci).length)" class="main-empty">
            <CalculationMainSkeleton />
        </div>
        <div v-else-if="dataLoaded && (!ci || typeof ci == 'object' && !Object.keys(ci).length)" class="main-empty"> {{ labels.no_module_chains_in_editor }}</div>
        <router-view name="calculation_share" module="calculation" />
    </div>
    </template>
    <script>
    // import Error from '@/components/Helpers/Error.vue';
    
    import CalculationInput from './CalculationComponents/CalculationInput.vue';
    import CalculationMainSkeleton from './CalculationComponents/CalculationMainSkeleton.vue'
    
    import prepareForm from '../services/prepare-formdata';
    
    import {
        mapActions,
        mapMutations,
        mapState
    } from 'vuex';
    
    export default {
        name: "CalculationMain",
        components: {
            // Error,
            CalculationInput,
            CalculationMainSkeleton
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            calculationId: {
                type: String
            }
        },
        data() {
            return {
                labels: {
                    no_selectable_value: 'No selectable value',
                    input_should_not_be_empty_for_variable: "Input should not be empty for variable",
                    select_value_for_variable: "Select value for variable",
                    no_selectable_value_for_variable: "No selectable value for variable",
                    calculation_has_no_module_chain: "Calculation has no Module Chain",
                    calculation_table_check: (varKey, editorId) => `Tabel should be set for variable: "${varKey}", editor id: "${editorId}". This variable is not rendered and calculation is not available until table is set.`,
                    calculation_parameter_check: (varKey, editorId) => `Parameter should be set for variable: "${varKey}", editor id: "${editorId}". This variable is not rendered and calculation is not available until parameter is set.`,
                    select_value_for_var: (varKey) => `Select value for variable: "${varKey}"`,
                    no_module_chains_in_editor: "No Module Chains in Editor",
                    no_parameters_exp_var: () => '',
                },
                executionResult: [],
                inputList: [],
                calcError: {},
                dataLoaded: false,
                executionId:false,
                data:null,
                canCalculate:false,
                canReset:false,
                location: 'client'
            }
        },
        computed: {
            ...mapState('calculation', {
                'ci': 'calculationInterface',
                'singleCalculation':'singleCalculation'
            }),        
            computedCalculationId() {
                if ( this.id ) return this.id
                if ( this.calculationId ) return this.calculationId
                return this.$route?.params?.id || 1;
            },
        },
    
        methods: {
            ...mapMutations('helper', ['setShadowLoaderStatus']),
            ...mapMutations('calculation',['updateInterfaceVariable','clearInterfaceVariable']),
            ...mapActions('notification',['addNotification']),
    
            ...mapActions('calculation', [
                'render', 
                'reset',
                'clientRender',
                'iframeRender', 
                'execute',
                'clientExecute', 
                'iframeExecute'
            ]),
            ...mapActions('table', ['getParameterData','getTableIframeData','getTableHeader']),
            valueChange(v,id){
                if(!this.data) this.data = {}
                this.data[id] = v
                this.setCanCalculate()
                this.setCanReset()
            },
            buildResultInput(variable) {
                return {
                    var_title: variable.title,
                    var_text: variable.text,
                    value: variable.result,
                    latex_title: variable.variable.latex_title,
                    latex_unit: variable.variable.latex_unit,
                    helpText: variable.variable.helpText
                }
            },
            reRenderWithUG(id){
                this.data = {}
                this.renderFN(id)
            },
            renderFN(ug, incoming) {
                let requestData = {
                    id: this.computedCalculationId,
                };
    
                let executionId = localStorage.getItem('execution_id_'+this.computedCalculationId)
                if(executionId) requestData.executionId = executionId
                if (incoming) requestData.incoming = incoming;
                if(ug) requestData.group = ug
    
                let renderFNName = 'render';
                if(this.location == 'client') renderFNName = 'clientRender';
                if(window.self !== window.top) renderFNName = 'iframeRender';
                
                return this[renderFNName](requestData)
                    .then(res => {
                        this.data = {}
                        this.dataLoaded = true;
                        if(res?.data?.executionId) localStorage.setItem('execution_id_'+this.computedCalculationId,res.data.executionId)
                        if (res.error) {
                            this.addNotification({ variant: 'danger', msg: res.error });
                        }
                        return res;
                    })
                    .catch(err => console.log(err));
            },
            
            sendData() {
                let payload = JSON.parse(JSON.stringify(this.data))
    
    
                let executeFNName = 'execute';
                if(this.location == 'client') executeFNName = 'clientExecute'
                if(window.self !== window.top) executeFNName = 'iframeExecute';
    
                return this[executeFNName](prepareForm({
                    id: this.computedCalculationId,
                    payload: payload,
                    executionId:this.executionId,
                    group: this.ci.currentgroup
                })).then(res => {
                    console.log('send data',res)
                    if(res.success){
                        if(res?.data?.executionId) localStorage.setItem('execution_id_'+this.computedCalculationId,res.data.executionId)
    
                        let exec_output;
                        let log = {}
                        try{
                            log = [];
                            let tmpLog = console.log;
                            console.logInclStdout = console.log.bind(console);
    
                            console.log = (logEntry) => {
                                log.push(logEntry);
                                console.logInclStdout.call(console, logEntry);
                            }
    
                            exec_output =  eval(res.code)
                            console.log = tmpLog
                        }catch(e){
                            log = e
                        }
                        this.data = {}
    
                        this.renderFN(this.ci.currentgroup,{
                            log:log,
                            result:exec_output,
                            id:this.ci.id
                        });
                    }else alert('error')
                }).catch(err => console.log(err))
            },
            resetCalculation() {
                let executionId = localStorage.getItem('execution_id_'+this.computedCalculationId)
                if(executionId){
                    this.reset(executionId).then(res => {
                        if (res.success) {
                            localStorage.removeItem('execution_id_'+this.computedCalculationId)
                            location.reload()
                        }
                    })
                }
            },
            setCanCalculate(){
                if(this.data == null) this.canCalculate = false
                else{
                    let check = true
                    if(!this.ci.request){
                        check = false
                    }else{
                        for(const key in this.ci.request){
                            if (Object.hasOwnProperty.call(this.ci.request, key)) {
                                if(this.data[key] === undefined) check = false
                                
                            }
                        }
                    }
                    console.log('this.ci.request',this.ci.request, this.data, check)
                    this.canCalculate = check
                }
            },
            setCanReset(){
                if(this.data == null || !this.ci) this.canReset = false
                else{
                    if(this.ci && !this.ci.next_id){
                        this.canReset = true
                    }else{
                        this.canReset = false 
                    }
                }
            }
        },
        mounted() {
            this.renderFN();
        },
        watch: {
            data(){
                this.setCanCalculate()
                this.setCanReset()
            }
        }
    }
    </script>
    
    <style lang="scss" scoped>
    .history-module-input {
        margin: 20px 0;
    }
    
    .history-module {
        margin: 20px 0;
    }
    
    .history-element {
        margin: 20px 0;
    }
    .user-groups {
        display: flex;
        .user-group {
            padding: 5px 10px;
            margin-right: 5px;
            background: #3fabe1;
            border-radius: 5px;
            color: white;
            cursor: pointer;
            &.active-group {
                background: #4085a8;
            }
            &:hover {
                background: #ddd;
            }
        }
    }
    
    .mc-children, .mc-child-input{
        margin:20px 0;
    }
    .calculate-btn{
        text-align: center;
        padding: 10px;
        background: #2ace2a;
        color: white;
        margin-top: 15px;
        border-radius: 3px;
        font-weight: bold;
        cursor:pointer;
        &.reset-calculate-btn{
            background: #f79f35;
        }
    }
    .main {
    
        .variables {
    
            &__interface {
                font-size: 0.9rem;
                margin-bottom: 25px;
            }
    
            .variable {
                margin-bottom: 20px;
    
                // &:last-child {
                //     margin-bottom: 0px;
                // }
    
                &-label {
                    font-weight: 400;
                    color: #B0AFB5;
                    font-size: 1rem;
                    margin-bottom: 10px;
                    min-height: 26px;
                    padding-right: 30px;
    
                    // .title {}
                    .unit {
                        margin-left: 15px;
                        color: #FCBD01;
                    }
                }
    
                &-select {
                    ::v-deep {
                        .dropdown.b-dropdown {
                            width: 100%;
    
                            .dropdown-toggle {
                                text-transform: unset;
                            }
                        }
                    }
                }
    
                &-table {
                    margin-bottom: 30px;
                }
            }
        }
    
        &-header {
            position: relative;
            margin-bottom: 2rem;
    
            &__title {
                font-weight: 700;
                color: #B0AFB5;
                margin-bottom: 1rem;
                padding-right: 150px;
            }
    
            &__description {
                color: #B0AFB5;
            }
    
            &__btn {
                position: absolute;
                right: 0;
                top: 0;
            }
        }
    
        &-result {
            >div {
                border-top: 1px solid #B0AFB5;
            }
        }
    
        &-input,
        &-result {
            margin: 1rem 0;
            padding-bottom: 1rem;
            font-size: .875rem;
    
            &__header {
                font-weight: 600;
                font-size: 1rem;
                margin-bottom: 0.75rem;
            }
    
            &__variables {
                // display: flex;
                // align-items: center;
    
                &__value,
                &__unit {
                    font-weight: 600;
                }
            }
        }
    
        // &-data {
        //     &__variables {}
        // }
    
        &-empty {
            font-size: 1.125rem;
            font-weight: 700;
            color: #B0AFB5;
            font-family: 'Lato';
        }
    }
    </style>
    